export default __webpack_public_path__ + "static/media/profile_avatar.ae1b094f.svg";